import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ISubscribePublicApiWebhook {
  url: string;
  active: boolean;
  signature_secret_key: string;
  events: Array<string>;
}

const subscribePublicApiWebhook = (postData: ISubscribePublicApiWebhook) => {
  return http().post(endpoints.integrations.publicApi.subscribeWebhook, postData);
};

export function useSubscribePublicApiWebhook() {
  return useMutation({ mutationFn: subscribePublicApiWebhook });
}
